export class Merchant {
    merchantKey: number;
    merchantName: string;
    zid: string;
    createDate: Date;
    status: any;
    merchantDisplayName: string;
    merchantSettings: any;
}